import React, { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import ModalDialogContent from "./ModalCreateNewPassword/ModalDialogContent";

const style = { //Estilos para el contenedor del modal.
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 730,
    bgcolor: 'var(--bg-border-by-mode)',
    border: '2px solid var(--bg-border-by-mode)',
    color: 'var(--bg-text-inbox-by-mode)',
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
};

// ModalCreateNewPassword: Componente que renderiza una ventana para restablecer contraseña 
// del usuario.

const ModalCreateNewPassword = ({ openCreateNewPassword, setOpenCreateNewPassword, setPasswordEditedSuccess }) => {
    const [open, setOpen] = useState(true);

    const [messageError, setMessageError] = useState(false);
    const [putPasswordError, setPutPasswordError] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenCreateNewPassword(false);
        setPutPasswordError(false);
        setMessageError(false)
    };

    useEffect(() => { setOpen(openCreateNewPassword) }, [openCreateNewPassword]);

    return (
        <>
            <Modal open={open} onClose={handleClose} >
                <Box sx={style}>
                    <DialogTitle sx={{ display: "flex", justifyContent: "right" }}>
                        <div className="container-title__change-password">
                            <div className="content-title__change-password">
                                <h3>Cambiar Contraseña</h3>
                            </div>
                            <div className="content-subTitle__change-password">
                                <p>Crea una contraseña nueva y segura</p>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

                        <ModalDialogContent setPasswordEditedSuccess={setPasswordEditedSuccess} messageError={messageError} 
                        setMessageError={setMessageError} putPasswordError={putPasswordError} setPutPasswordError={setPutPasswordError}
                        setOpenCreateNewPassword={setOpenCreateNewPassword} />

                    </DialogContent>
                </Box>
            </Modal>
        </>
    );
};

export default ModalCreateNewPassword;